import alertMessage from 'global/AlertMessage';
import chatApi from 'lib/api/chat';
import create from 'zustand';
import { IRoomDetailStore } from './types';

const roomDetailStore = create<IRoomDetailStore>((set, get) => ({
  personal: {},
  group: {},
  isLoading: false,
  isLoadingUpdateGroup: false,
  isLoadingResetLink: false,
  fetchPersonalRoomDetail: async (chatId) =>
    new Promise((resolve) => {
      chatApi
        .getRoom(chatId)
        .then((res) => {
          const { data } = res.data;
          set({ personal: { ...get().personal, [chatId]: data } });
          resolve({ data, error: false });
        })
        .catch(() => {
          resolve({ error: true });
        });
    }),
  fetchGroupRoomDetail: async (chatId) =>
    new Promise((resolve) => {
      chatApi
        .getGroupRoom(chatId)
        .then((res) => {
          const { data } = res.data;

          set({ group: { ...get().group, [chatId]: data } });
          resolve({ data, error: false });
        })
        .catch(() => {
          resolve({ error: true });
        });
    }),
  updateGroupRoomDetail: async (params) =>
    new Promise((resolve) => {
      const { chatId, groupId, ...restParams } = params;
      chatApi
        .updateChatGroup(groupId, restParams)
        .then(async () => {
          await chatApi
            .getGroupRoom(chatId)
            .then((resGroupDetail) => {
              const { data } = resGroupDetail.data;
              set({ group: { ...get().group, [chatId]: data } });
              resolve(true);
            })
            .catch(() => {
              set({ isLoadingUpdateGroup: false });
            });
        })
        .catch(() => {
          set({ isLoadingUpdateGroup: false });
        });
    }),
  resetGroupLink: async (params) => {
    const { groupId, chatId } = params;
    await chatApi
      .resetLink(groupId)
      .then(async (res) => {
        const { data } = res.data;
        set({
          group: {
            ...get().group,
            [chatId]: {
              ...get().group[chatId],
              invitation_link: data?.new_link,
            },
          },
          isLoadingResetLink: false,
        });
      })
      .catch((err) => {
        if (err?.cause?.status === 403) {
          alertMessage({
            content: err?.cause?.message,
            alertType: 'plain-default',
            messageType: 'error',
          });
        }
        set({ isLoadingResetLink: false });
      });
  },
  refreshGroupRoomDetail: async (chatId) =>
    new Promise((resolve) => {
      chatApi
        .getGroupRoomSilent(chatId)
        .then((res) => {
          const { data } = res.data;
          set({ group: { ...get().group, [chatId]: data } });
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    }),
}));

export default roomDetailStore;
